import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApprovalMatrixService } from '../../../Model/ApprovalMatrix/approval-matrix.service';
import { ComboService } from '../../../Model/Combo/combo.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { RegularizationService } from '../../../Model/Regularization/regularization.service';
import { ApprovalMatrixFormFilterComponent } from '../../ApprovalMatrixFormFilter/approval-matrix-form-filter/approval-matrix-form-filter.component';
import { NgbModal, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SessionService } from '../../../Util/Session/session.service';
import { CommonService } from '../../../Model/Common/common.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';

@Component({
  selector: 'app-regularization-policies-form',
  standalone: true,
  imports: [CommonModule, FormsModule, NgbTooltip, LoaderComponent],
  templateUrl: './regularization-policies-form.component.html',
  styleUrl: './regularization-policies-form.component.scss'
})
export class RegularizationPoliciesFormComponent {
  isDisabled: boolean = false;
  isPageDisabled: boolean = true;
  LastWebESSApplicabilityId = null;
  ApplicabilityDatas = [] as any;
  ApplicabilityDatasFilter = [] as any;
  Applicabilitys = [] as any;
  ApprovalSubCategory = [] as any;
  ApprovalSubCategoryFilter = [] as any;
  Companys = [] as any;
  CompanysFilter = [] as any;
  Departments = [] as any;
  DepartmentsFilter = [] as any;
  Users = [] as any;
  UsersFilter = [] as any;
  Branchs = [] as any;
  BranchsFilter = [] as any;
  Clients = [] as any;
  ClientsFilter = [] as any;
  Sites = [] as any;
  SitesFilter = [] as any;
  Designations = [] as any;
  DesignationsFilter = [] as any;
  Grades = [] as any;
  GradesFilter = [] as any;

  RegularizationRuleDetail = {
    SelectType: 'insert',
    ESS_RegularizationRuleID: 0,
    RegularizationRuleTitle: null,
    IsRegularizationForFutureDate: false,
    TillDateRequestForRegularization: null,
    AllowRegularizationForDays: null as any,
    AllowRegularizationFor: null,
    AllowRegularizationForSameDays: false,
    AllowRegulariationForPreviousMonth: false,
    DefaultRegularization: false,
    WebESSApplicabilityId: null as any,
    MappedId: null as any,
    EmpType: 'FRONT',
    AllowRequestAfterMonthlock:false,
  }

  Filter = {
    BranchID: null,
    ClientID: null,
    SiteID: null,
  }

  constructor(
    private toast: ToastService,
    private session: SessionService,
    private combo: ComboService,
    private approvalMatrix: ApprovalMatrixService,
    private regularization: RegularizationService,
    private router: Router,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    protected common: CommonService,
    protected tooltip: TooltipService
  ) {
    this.common.getPageRights();
    this.route.params.subscribe(params => this.RegularizationRuleDetail.ESS_RegularizationRuleID = parseInt(params['id']));
  }

  ngOnInit(): void {
    if (this.RegularizationRuleDetail.ESS_RegularizationRuleID > 0) {
      this.RegularizationRuleSelectUpdate();
    } else {
      this.GetApplicability();
    }
  }

  ngAfterViewInit() {
    this.isPageDisabled = false;
  }

  Validate(form: any) {
    if (form.valid) {
      this.RegularizationRuleInsertUpdate();
    }
    else {
      form.submitted = true;
    }
  }

  RegularizationRuleSelectUpdate() {
    this.isDisabled = true;
    this.regularization.RegularizationRuleSelectUpdate({ SelectType: 1, ESS_RegularizationRuleID: this.RegularizationRuleDetail.ESS_RegularizationRuleID }).subscribe({
      next: (response) => {
        if (response.Table[0].EmpType == null || response.Table[0].EmpType == '') {
          response.Table[0].EmpType = 'FRONT';
        } else {
          response.Table[0].EmpType = response.Table[0].EmpType.toUpperCase();
        }

        if (response.Table[0].AllowRegulariationForPreviousMonth == null) {
          response.Table[0].AllowRegulariationForPreviousMonth = false;
        }

        this.RegularizationRuleDetail = response.Table[0];
        this.RegularizationRuleDetail.MappedId = response.Table2.map((e: any) => e.MappedId).toString();
        this.RegularizationRuleDetail.SelectType = 'update';
        this.LastWebESSApplicabilityId = this.RegularizationRuleDetail.WebESSApplicabilityId;
        if (this.RegularizationRuleDetail.WebESSApplicabilityId == 1) {
          this.ApprovalComboLoad('Company');
        } else if (this.RegularizationRuleDetail.WebESSApplicabilityId == 2) {
          this.ApprovalComboLoad('Branch');
        } else if (this.RegularizationRuleDetail.WebESSApplicabilityId == 3) {
          //this.ApprovalComboLoad('Client');
          response.Table2.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.MappedId,
                ApplicabilityData: element.MappedValue,
                WebESSApplicabilityId: this.RegularizationRuleDetail.WebESSApplicabilityId,
                IsCheck: true
              }
            );
          });
          this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        } else if (this.RegularizationRuleDetail.WebESSApplicabilityId == 4) {
          //this.ApprovalComboLoad('Site');
          response.Table2.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.MappedId,
                ApplicabilityData: element.MappedValue,
                WebESSApplicabilityId: this.RegularizationRuleDetail.WebESSApplicabilityId,
                IsCheck: true
              }
            );
          });
          this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        } else if (this.RegularizationRuleDetail.WebESSApplicabilityId == 5) {
          this.ApprovalComboLoad('Department');
        } else if (this.RegularizationRuleDetail.WebESSApplicabilityId == 6) {
          this.ApprovalComboLoad('Designation');
        } else if (this.RegularizationRuleDetail.WebESSApplicabilityId == 7) {
          this.ApprovalComboLoad('User');
        } else if (this.RegularizationRuleDetail.WebESSApplicabilityId == 8) {
          // response.Table2.map((e: any) => e.MappedId).forEach((element: any) => {
          //   this.ComboLoad('EmpLoadOnId', element);
          // });
          response.Table2.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.MappedId,
                ApplicabilityData: element.MappedValue,
                WebESSApplicabilityId: this.RegularizationRuleDetail.WebESSApplicabilityId,
                IsCheck: true
              }
            );
          });
          this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        } else if (this.RegularizationRuleDetail.WebESSApplicabilityId == 9) {
          this.ApprovalComboLoad('Grade');
        } 
        if (this.RegularizationRuleDetail.WebESSApplicabilityId == 8) {
          this.GetApplicability(false);
        } else {
          this.GetApplicability();
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  GetApplicability(IsClear = true) {
    this.isDisabled = true;
    this.approvalMatrix.GetApplicability({ SelectType: 'SR', WebESSApplicabilityMasterID: 0, EmpType: this.RegularizationRuleDetail.EmpType }).subscribe({
      next: (response) => {
        this.Applicabilitys = response.Table;
        if (response.Table.findIndex((e: any) => e.WebESSApplicabilityMasterID == 0) >= 0) {
          this.Applicabilitys.push(response.Table.filter((e: any) => e.WebESSApplicabilityMasterID == 0)[0]);
          this.Applicabilitys.splice(this.Applicabilitys.findIndex((e: any) => e.WebESSApplicabilityMasterID == 0), 1);
        }
        if (this.Applicabilitys.filter((e: any) => e.WebESSApplicabilityMasterID == this.RegularizationRuleDetail.WebESSApplicabilityId).length == 0) {
          this.RegularizationRuleDetail.WebESSApplicabilityId = null;
          this.ApplicabilityDatasFilter = [];
        } else if (this.RegularizationRuleDetail.WebESSApplicabilityId == 8 && IsClear) {
          this.ApplicabilityDatasFilter = [];
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  async ApplicabilityDataFilter(IsFilter = false) {
    // if (this.RegularizationRuleDetail.WebESSApplicabilityId != 8 || !IsFilter) {
    //   this.ApplicabilityDatas = [];
    //   this.ApplicabilityDatasFilter = [];
    // }
    if (IsFilter || await this.Confirmation(IsFilter)) {
      if (!IsFilter) {
        this.ApplicabilityDatas = [];
        this.ApplicabilityDatasFilter = [];
        this.RegularizationRuleDetail.MappedId = null;
        this.LastWebESSApplicabilityId = this.RegularizationRuleDetail.WebESSApplicabilityId;
      } else {
        this.ApplicabilityDatas = this.ApplicabilityDatasFilter.filter((e: any) => e.IsCheck);
        this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
      }

      this.Filter.BranchID = null;
      this.Filter.ClientID = null;
      this.Filter.SiteID = null;
      if (this.RegularizationRuleDetail.WebESSApplicabilityId == 1) {
        this.ApprovalComboLoad('Company');
      } else if (this.RegularizationRuleDetail.WebESSApplicabilityId == 2) {
        this.ApprovalComboLoad('Branch');
      } else if (this.RegularizationRuleDetail.WebESSApplicabilityId == 5) {
        this.ApprovalComboLoad('Department');
      } else if (this.RegularizationRuleDetail.WebESSApplicabilityId == 6) {
        this.ApprovalComboLoad('Designation');
      } else if (this.RegularizationRuleDetail.WebESSApplicabilityId == 7) {
        this.ApprovalComboLoad('User');
      } else if (this.RegularizationRuleDetail.WebESSApplicabilityId == 9) {
        this.ApprovalComboLoad('Grade');
      } else {
        if (this.RegularizationRuleDetail.WebESSApplicabilityId != 0) {
          this.FilterForm();
        }
      }
    }
  }

  async Confirmation(IsFilter = false): Promise<boolean> {
    if (!IsFilter && this.LastWebESSApplicabilityId != null) {
      const modalRef = this.modalService.open(ConfirmationComponent);
      modalRef.componentInstance.Message = this.tooltip.Message.ApplicabiliyChangeMessgae;
      modalRef.componentInstance.Message2 = this.tooltip.Message.ApplicabiliyChangeMessgae2;
      return modalRef.result.then((result) => {
        if (!result) {
          this.RegularizationRuleDetail.WebESSApplicabilityId = this.LastWebESSApplicabilityId;
        }
        return result;
      });
    } else {
      return true;
    }
  }

  ButtonApplicabilityDataFilter(id = 0) {
    if (
      (id == 3 || id == 4 || id == 8) ||
      (id == 0 && (this.RegularizationRuleDetail.WebESSApplicabilityId == 3 || this.RegularizationRuleDetail.WebESSApplicabilityId == 4 || this.RegularizationRuleDetail.WebESSApplicabilityId == 8))) {
      this.ApplicabilityDataFilter(true);
    } else {
      this.toast.show({ message: "Filter only allow for client & site", type: toastTypeEnum.warning });
    }
  }

  ApprovalComboLoad(Combotype: String, Combotype2 = null as any, index = 0) {
    this.isDisabled = true;
    this.combo.ApprovalComboLoad({
      'SelectType': Combotype,
      'BranchId': this.Filter.BranchID,
      'ClientId': this.Filter.ClientID,
    }).subscribe({
      next: (response) => {
        if (Combotype == 'Company') {
          this.Companys = response.Table.filter((e: any) => e.CompanyMasterId == parseInt(this.session.GetUserDetails().CompanyMasterId));
          this.CompanysFilter = response.Table.filter((e: any) => e.CompanyMasterId == parseInt(this.session.GetUserDetails().CompanyMasterId));

          this.Companys.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.CompanyMasterId,
                ApplicabilityData: element.CompanyName,
                WebESSApplicabilityId: this.RegularizationRuleDetail.WebESSApplicabilityId,
                IsCheck: this.RegularizationRuleDetail.MappedId != null ? this.RegularizationRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.CompanyMasterId) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'Branch') {
          this.Branchs = response.Table;
          this.BranchsFilter = response.Table;

          this.Branchs.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.BranchMasterID,
                ApplicabilityData: element.BranchName,
                WebESSApplicabilityId: this.RegularizationRuleDetail.WebESSApplicabilityId,
                IsCheck: this.RegularizationRuleDetail.MappedId != null ? this.RegularizationRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.BranchMasterID) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'Department') {
          this.Departments = response.Table;
          this.DepartmentsFilter = response.Table;

          this.Departments.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.DepartmentMasterID,
                ApplicabilityData: element.DepartmentName,
                WebESSApplicabilityId: this.RegularizationRuleDetail.WebESSApplicabilityId,
                IsCheck: this.RegularizationRuleDetail.MappedId != null ? this.RegularizationRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.DepartmentMasterID) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'Designation') {
          this.Designations = response.Table;
          this.DesignationsFilter = response.Table;

          this.Designations.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.DesignationMasterID,
                ApplicabilityData: element.DesignationName,
                WebESSApplicabilityId: this.RegularizationRuleDetail.WebESSApplicabilityId,
                IsCheck: this.RegularizationRuleDetail.MappedId != null ? this.RegularizationRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.DesignationMasterID) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'Client') {
          this.Clients = response.Table;
          this.ClientsFilter = response.Table;

          this.Clients.forEach((element: any) => {
            if (this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityDataID == element.ClientGroupMasterID).length == 0) {
              this.ApplicabilityDatas.push(
                {
                  ApplicabilityDataID: element.ClientGroupMasterID,
                  ApplicabilityData: element.ClientGroupName,
                  WebESSApplicabilityId: this.RegularizationRuleDetail.WebESSApplicabilityId,
                  IsCheck: this.RegularizationRuleDetail.MappedId != null ? this.RegularizationRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.ClientGroupMasterID) >= 0 ? true : false : false,
                }
              );
            }
          });
        } else if (Combotype == 'Site') {
          this.Sites = response.Table;
          this.SitesFilter = response.Table;

          this.Sites.forEach((element: any) => {
            if (this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityDataID == element.SiteMasterID).length == 0) {
              this.ApplicabilityDatas.push(
                {
                  ApplicabilityDataID: element.SiteMasterID,
                  ApplicabilityData: element.SiteName,
                  WebESSApplicabilityId: this.RegularizationRuleDetail.WebESSApplicabilityId,
                  IsCheck: this.RegularizationRuleDetail.MappedId != null ? this.RegularizationRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.SiteMasterID) >= 0 ? true : false : false,
                }
              );
            }
          });
        } else if (Combotype == 'Designation') {
          this.Designations = response.ComboLoad;
          this.DesignationsFilter = response.ComboLoad;

          this.Designations.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.BranchMasterID,
                ApplicabilityData: element.BranchName,
                WebESSApplicabilityId: this.RegularizationRuleDetail.WebESSApplicabilityId,
                IsCheck: this.RegularizationRuleDetail.MappedId != null ? this.RegularizationRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.BranchMasterID) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'User' && Combotype2 == null) {
          this.Users = response.Table;
          this.UsersFilter = response.Table;

          this.Users.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.UserMasterId,
                ApplicabilityData: element.UserName,
                WebESSApplicabilityId: this.RegularizationRuleDetail.WebESSApplicabilityId,
                IsCheck: this.RegularizationRuleDetail.MappedId != null ? this.RegularizationRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.UserMasterId) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'User' && Combotype2 == 'Employee') {
          response.Table.forEach((element: any) => {
            this.ApprovalSubCategory.push(
              {
                ApprovalSubCategoryID: element.UserMasterId,
                ApprovalSubCategory: element.UserName,
              }
            );
          });
          this.ApprovalSubCategoryFilter[index] = this.ApprovalSubCategory;
        } else if (Combotype == 'Grade') {
          this.Grades = response.Table;
          this.GradesFilter = response.Table;

          this.Grades.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.GradeMasterId,
                ApplicabilityData: element.GradeName,
                WebESSApplicabilityId: this.RegularizationRuleDetail.WebESSApplicabilityId,
                IsCheck: this.RegularizationRuleDetail.MappedId != null ? this.RegularizationRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.GradeMasterId) >= 0 ? true : false : false,
              }
            );
          });
        }
        this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        this.RegularizationRuleDetail.MappedId = null;
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  FilterForm() {
    const modalRef = this.modalService.open(ApprovalMatrixFormFilterComponent, { size: 'lg' });
    modalRef.componentInstance.Title = this.RegularizationRuleDetail.WebESSApplicabilityId == 3 ? 'Client' : this.RegularizationRuleDetail.WebESSApplicabilityId == 4 ? 'Site' : this.RegularizationRuleDetail.WebESSApplicabilityId == 8 ? 'Employee' : '';
    modalRef.componentInstance.WebESSApplicabilityId = this.RegularizationRuleDetail.WebESSApplicabilityId;
    modalRef.componentInstance.EmpType = this.RegularizationRuleDetail.EmpType;
    modalRef.componentInstance.ShowFilter = {
      ShowBranch: (this.RegularizationRuleDetail.WebESSApplicabilityId == 3 || this.RegularizationRuleDetail.WebESSApplicabilityId == 4 || this.RegularizationRuleDetail.WebESSApplicabilityId == 6) ? true : false,
      ShowClient: (this.RegularizationRuleDetail.WebESSApplicabilityId == 4 || this.RegularizationRuleDetail.WebESSApplicabilityId == 6) ? true : false,
      ShowSite: (this.RegularizationRuleDetail.WebESSApplicabilityId == 6) ? true : false,
      ShowSearchEmployee: (this.RegularizationRuleDetail.WebESSApplicabilityId == 8 || this.RegularizationRuleDetail.WebESSApplicabilityId == 4) ? true : false
    }
    modalRef.result.then(result => {
      this.Filter.BranchID = result.BranchID;
      this.Filter.ClientID = result.ClientID;
      this.Filter.SiteID = result.SiteID;
      if (this.RegularizationRuleDetail.WebESSApplicabilityId == 1) {
        //this.ApprovalComboLoad('Company');
      } else if (this.RegularizationRuleDetail.WebESSApplicabilityId == 2) {
        this.ApprovalComboLoad('Branch');
      } else if (this.RegularizationRuleDetail.WebESSApplicabilityId == 3) {
        this.ApprovalComboLoad('Client');
      } else if (this.RegularizationRuleDetail.WebESSApplicabilityId == 4) {
        if (result.length >= 0) {
          result.forEach((element: any) => {
            if (this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityDataID == element.SiteMasterID).length == 0) {
              this.ApplicabilityDatas.push(
                {
                  ApplicabilityDataID: element.SiteMasterID,
                  ApplicabilityData: element.SiteCode + '-' + element.SiteName,
                  WebESSApplicabilityId: this.RegularizationRuleDetail.WebESSApplicabilityId,
                  IsCheck: true,
                }
              );
            }
          });
          this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        } else {
          this.ApprovalComboLoad('Site');
        }
      } else if (this.RegularizationRuleDetail.WebESSApplicabilityId == 5) {
        //this.ComboLoad('Department');
      } else if (this.RegularizationRuleDetail.WebESSApplicabilityId == 6) {
        //this.ComboLoad('Designation');
      } else if (this.RegularizationRuleDetail.WebESSApplicabilityId == 7) {
        //this.ComboLoad('User');
      } else if (this.RegularizationRuleDetail.WebESSApplicabilityId == 8) {
        if (result != undefined) {
          result.forEach((element: any) => {
            if (this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityDataID == element.EmpMasterID).length == 0) {
              this.ApplicabilityDatas.push(
                {
                  ApplicabilityDataID: element.EmpMasterID,
                  ApplicabilityData: element.FullName,
                  WebESSApplicabilityId: this.RegularizationRuleDetail.WebESSApplicabilityId,
                  IsCheck: true
                }
              );
            }
          });
          this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        }
      }
    });
  }

  ApplicabilityCheckAll(event: any) {
    this.ApplicabilityDatasFilter.map((e: any) => e.IsCheck = event.target.checked);
  }

  async RegularizationRuleInsertUpdate() {
    await this.common.getPageRights();
    this.SearchDropdown('', 'Applicability');
    if (this.common.parseFloat(this.RegularizationRuleDetail.TillDateRequestForRegularization) > 365) {
      this.toast.show({ message: 'Regularization request can be raised for maximum 365 days', type: toastTypeEnum.warning });
    } else if (this.RegularizationRuleDetail.AllowRegularizationFor == null) {
      this.toast.show({ message: 'Please select allow for days', type: toastTypeEnum.warning });
    } else if (this.RegularizationRuleDetail.EmpType != 'FRONT' && this.RegularizationRuleDetail.EmpType != 'BACK') {
      this.toast.show({ message: 'Please select applicable for', type: toastTypeEnum.warning });
    } else if (this.RegularizationRuleDetail.WebESSApplicabilityId == null) {
      this.toast.show({ message: 'Please select applicability', type: toastTypeEnum.warning });
    } else if (this.RegularizationRuleDetail.WebESSApplicabilityId > 0 && this.ApplicabilityDatasFilter.filter((e: any) => e.IsCheck).length == 0) {
      this.toast.show({ message: 'Please select sub applicability', type: toastTypeEnum.warning });
    } else if (this.RegularizationRuleDetail.WebESSApplicabilityId == 0 && this.RegularizationRuleDetail.DefaultRegularization) {
      this.toast.show({ message: "Applicability none not allow for default rule yes", type: toastTypeEnum.warning });
    } else {
      const modalRef = this.modalService.open(ConfirmationComponent);
      modalRef.componentInstance.Message = 'Do you want to save?';
      modalRef.result.then(result => {
        if ((this.common.PageRight.IsAdd && this.RegularizationRuleDetail.ESS_RegularizationRuleID == 0) || (this.common.PageRight.IsEdit && this.RegularizationRuleDetail.ESS_RegularizationRuleID > 0)) {
          if (result) {
            this.isDisabled = true;
            if (this.RegularizationRuleDetail.AllowRegularizationForDays == null || this.RegularizationRuleDetail.AllowRegularizationForDays.toString().replace(/\s/g, "") == '') {
              this.RegularizationRuleDetail.AllowRegularizationForDays = 0;
            }
            this.RegularizationRuleDetail.MappedId = this.ApplicabilityDatasFilter.filter((e: any) => e.IsCheck && e.WebESSApplicabilityId == this.RegularizationRuleDetail.WebESSApplicabilityId).map((e: any) => e.ApplicabilityDataID).toString();
            this.regularization.RegularizationRuleInsertUpdate(this.RegularizationRuleDetail).subscribe({
              next: (response) => {
                if (response.Error_Code == "01") {
                  this.close();
                  this.toast.show({ message: response.Error_Message, type: toastTypeEnum.success });
                } else {
                  this.toast.show({ message: response.Error_Message, type: toastTypeEnum.danger });
                }
                this.isDisabled = false;
              },
              complete: () => { },
              error: (error) => {
                this.isDisabled = false;
              },
            });
          }
        } else {
          this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
        }
      });
    }
  }

  SearchDropdown(SearchValue: string, Label: string) {
    if (Label == 'Applicability') {
      this.ApplicabilityDatasFilter = this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityData.toLowerCase().includes(SearchValue.toLowerCase()));
    }
  }

  ComboLoad(Combotype: String, id: number) {
    this.isDisabled = true;
    this.combo.ComboLoad({ 'Combotype': Combotype, 'EmpMasterID': id, 'EmpType': this.RegularizationRuleDetail.EmpType, }).subscribe({
      next: (response) => {
        if (Combotype == 'EmpLoadOnId') {
          if (response.ComboLoad.length > 0) {
            if (this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityDataID == response.ComboLoad[0].EmpMasterID).length == 0) {
              this.ApplicabilityDatas.push(
                {
                  ApplicabilityDataID: response.ComboLoad[0].EmpMasterID,
                  ApplicabilityData: response.ComboLoad[0].FullName,
                  WebESSApplicabilityId: this.RegularizationRuleDetail.WebESSApplicabilityId,
                  IsCheck: true
                }
              );
            }
          }

        }
        this.isDisabled = false;
      },
      complete: () => {

      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  OrderByApplicability() {
    return this.ApplicabilityDatasFilter.sort((a: any, b: any) => a.ApplicabilityData.localeCompare(b.ApplicabilityData));
  }

  close() {
    this.router.navigate(['/setting/regularizationpolicies/']);
  }
}
